import { mountCoreVueApp } from '@/entrypoints/helpers/core-vue-app';
import PatternDownload from '@/shared/components/patterns/PatternDownload.vue';
import GlobalKeyDownDirective from '@/shared/directives/globalKeyDown.js';
import { useProductStore } from '@/shared/pinia/modules/product';
import { useUserStore } from '@/shared/pinia/modules/user';
import {
  getProductDataFromHTML,
  setCartButtonBlockVisible
} from '@/shared/utils/product';

export const initPatternDownload = async (mountId) => {
  const mountElement = document.getElementById(mountId);

  if (!mountElement) {
    console.error(`Element with id: "${mountId}" not found.`);
    return;
  }

  const { productName, legacyId } = getProductDataFromHTML();
  const {
    productSku,
    freePattern,
    productImageUrl,
    localeLanguage,
    localeCountry,
    localeMarket
  } = mountElement.dataset;
  // `freePattern` is the raw "true"/"false" string; paid patterns must mount
  // too so owners get the download button.
  if (!productName || !productSku || !freePattern) return;

  const patternPurchasable = freePattern === 'false';

  // Hidden before any app mounts so an owner never sees the cart row flash;
  // PatternDownload shows it again if the ownership check finds no purchase.
  if (patternPurchasable && useUserStore().isLogged) {
    setCartButtonBlockVisible(false);
  }

  const productStore = useProductStore();
  productStore.legacyId = legacyId;

  await mountCoreVueApp(
    PatternDownload,
    `#${mountId}`,
    {
      productName,
      productSku,
      patternPurchasable,
      productImageUrl: productImageUrl || '',
      localeLanguage: localeLanguage || '',
      localeCountry: localeCountry || '',
      localeMarket: localeMarket || ''
    },
    (app) => {
      app.directive('global-keydown', GlobalKeyDownDirective);
    },
    { noClients: true }
  );
};
